import React from "react";
import { NavLink } from "react-router-dom";
import { Sunrise, BarChart3, BookOpen, User } from "lucide-react";

const items = [
  { to: "/", label: "Today", icon: Sunrise, testid: "nav-today" },
  { to: "/library", label: "Library", icon: BarChart3, testid: "nav-library" },
  { to: "/journal", label: "Journal", icon: BookOpen, testid: "nav-journal" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

const BottomNav = () => {
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white/85 backdrop-blur-xl border-t border-[#E2EBE6] flex justify-around items-center py-3 px-4 z-50"
      data-testid="bottom-nav"
    >
      {items.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 px-3 py-1.5 rounded-2xl transition-colors no-tap-highlight ${
              isActive ? "text-[#234B38]" : "text-[#5C7568]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
              <span className={`text-[10px] tracking-wide ${isActive ? "font-semibold" : "font-medium"}`}>
                {label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;
